module.exports = __webpack_public_path__ + "img/progressActive.adf04992.svg";